var _rect, _rect2, _line, _line2, _line3, _line4, _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFq16(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.22188,
    y: 0.796094,
    width: 48.972,
    height: 48.972,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.4582,
    y: 12.0305,
    width: 26.4993,
    height: 26.4993,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 39.0457,
    y1: 12.1824,
    x2: 50.282,
    y2: 0.946085,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 1.37185,
    y1: 49.8543,
    x2: 12.6082,
    y2: 38.618,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 38.8078,
    y1: 38.6199,
    x2: 50.0441,
    y2: 49.8562,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 1.13401,
    y1: 0.944118,
    x2: 12.3703,
    y2: 12.1804,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.434 22.844V21.962H20.814V32H19.82V22.844H18.434ZM28.7659 24.412C28.5606 23.1987 27.8559 22.592 26.6519 22.592C25.7372 22.592 25.0512 22.9467 24.5939 23.656C24.1366 24.3653 23.9266 25.5273 23.9639 27.142C24.1506 26.582 24.5052 26.1433 25.0279 25.826C25.5599 25.4993 26.1666 25.336 26.8479 25.336C27.8279 25.336 28.6026 25.6393 29.1719 26.246C29.7506 26.8433 30.0399 27.6693 30.0399 28.724C30.0399 29.34 29.9186 29.9 29.6759 30.404C29.4426 30.8987 29.0786 31.2953 28.5839 31.594C28.0986 31.8927 27.4919 32.042 26.7639 32.042C25.3732 32.042 24.4119 31.5987 23.8799 30.712C23.3572 29.8253 23.0959 28.57 23.0959 26.946C23.0959 23.4927 24.2812 21.766 26.6519 21.766C27.5479 21.766 28.2526 22.0133 28.7659 22.508C29.2792 22.9933 29.5826 23.628 29.6759 24.412H28.7659ZM26.6659 26.176C26.2272 26.176 25.8119 26.2647 25.4199 26.442C25.0279 26.6193 24.7059 26.89 24.4539 27.254C24.2112 27.6087 24.0899 28.0473 24.0899 28.57C24.0899 29.326 24.3139 29.956 24.7619 30.46C25.2099 30.964 25.8632 31.216 26.7219 31.216C27.4406 31.216 28.0146 30.9967 28.4439 30.558C28.8732 30.1193 29.0879 29.522 29.0879 28.766C29.0879 27.954 28.8779 27.3193 28.4579 26.862C28.0379 26.4047 27.4406 26.176 26.6659 26.176Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFq16);
export default __webpack_public_path__ + "static/media/fq16.a629f2b8b5ce2d2e0247927fe235bcb1.svg";
export { ForwardRef as ReactComponent };